module.exports = __webpack_public_path__ + "img/full5-min.1d390365.png";